import React from "react";
import { Container } from "react-bootstrap";
import ListView from "../../../components/listView/ListView";
import { categoryFilterMeta } from "../../../configs/meta/filterMeta/categoryFilterMeta";
import blogListViewMeta from "../../../configs/meta/listViewMeta/blogListViewMeta";

const Blog = () => (
  <React.Fragment>
    <Container fluid className="p-0">
      <ListView
        filters={categoryFilterMeta}
        meta={blogListViewMeta()}
        title="Blog List"
      />
    </Container>
  </React.Fragment>
);

export default Blog;
